import {CustomIconLink} from "@/app/[locale]/common/components/CustomIconLink/CustomIconLink";
import s from './TextIconLink.module.scss';
import {TTextIconLinkProps} from "@/app/[locale]/common/components/TextIconLink/types";

export const TextIconLink = ({ children, className, icon, href }: TTextIconLinkProps) => {
    return (
        <CustomIconLink
            href={href}
            rightIcon={icon}
            className={`${s.link} ${className}`}
        >
            { children }
        </CustomIconLink>
    );
};